<script setup lang="ts">

import { computed } from "vue";
import { DefaultSections, usePresentation } from "@presentation/Types";
import { useUserSettings } from "@modules/Services/UserSettings";

const presentation = usePresentation();

const isAtEnd = computed( () => presentation.isAtEnd );
const hasNextSlide = computed( () => isAtEnd.value == false && ( presentation.currentSection.isAppendix == false || presentation.pageIndex < presentation.currentSection.pages.length - 1  ) );
const nextSlide = computed( () => {
    if( hasNextSlide.value == false ) return;
    if( [ DefaultSections.Start, DefaultSections.End, DefaultSections.SlideSorter ].indexOf( presentation.active ) >= 0 ) return; 
    if( presentation.pageIndex == presentation.currentSection.pages.length - 1 )
    {
        const sectionIndex = presentation.sections.findIndex( s => s.name == presentation.active );
        const nextSection = presentation.sections[ sectionIndex + 1 ];
        if( nextSection.isAppendix ) return;
        return presentation.sections[ sectionIndex + 1 ].pages[ 0 ];
    }
    return presentation.currentSection.pages[ presentation.pageIndex + 1 ];
});

const settings = useUserSettings();

</script>

<template>

    <!-- NEXT SLIDE -->
    <div class="absolute bottom-4 left-4 flex items-center 2xl:scale-110 2xl:bottom-6 2xl:left-7">

        <transition mode="out-in"
            enter-active-class="transition ease-out duration-150"
            enter-from-class="transform opacity-0 scale-95 translate-y-20"
            enter-to-class="transform opacity-100 scale-100 translate-y-0"
            leave-active-class="transition ease-in duration-150"
            leave-from-class="transform opacity-100 scale-100 translate-y-0"
            leave-to-class="transform opacity-0 scale-95 translate-y-20">
            
            <div v-if="nextSlide != null && hasNextSlide">
                <div v-if="settings.presentationShowNextSlide"
                     class="w-32">
                    <img 
                        v-if="nextSlide != null" 
                        :src="nextSlide.screenshot" 
                        class="rounded-lg shadow-xl ring-1 ring-gray-900"
                        :onerror="`this.src = '/images/${presentation.key}/pending.jpg'`" 
                    />
                </div>
                <div class="text-xs whitespace-nowrap pl-1.5 pt-1 opacity-70">Next: <span class="opacity-60">{{ nextSlide.title }}</span></div>

                <IconButton 
                    name="arrow-left" 
                    class="transition-all duration-300 absolute -left-1 scale-75 -top-10" 
                    :class="settings.presentationShowNextSlide ? '-rotate-90 !opacity-50' : 'rotate-[90deg]'" 
                    @click="() => settings.presentationShowNextSlide = !settings.presentationShowNextSlide"
                />

            </div>

        </transition>   

    </div>

</template>